export const STOCK_DIRECTIONS_SET = 'STOCK_DIRECTIONS_SET'
export const STOCK_DIRECTIONS_FETCHING = 'STOCK_DIRECTIONS_FETCHING'
